"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const DeviationBlocker = (props) => (react_1.default.createElement(core_1.SvgIcon, Object.assign({ viewBox: "0 0 24 24" }, props),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("clipPath", { id: "clip-icon_deviation_blocker" },
            react_1.default.createElement("rect", { width: "24", height: "24" }))),
    react_1.default.createElement("g", { id: "icon_deviation_blocker", clipPath: "url(#clip-icon_deviation_blocker)" },
        react_1.default.createElement("g", { id: "icon_deviation_blocker-2", "data-name": "icon_deviation_blocker" },
            react_1.default.createElement("rect", { id: "Background", width: "24", height: "24", fill: "none" }),
            react_1.default.createElement("g", { id: "Ellipse_100", "data-name": "Ellipse 100", transform: "translate(1 1)", fill: "#ff2a31", stroke: "#b9b9b9", strokeWidth: "1" },
                react_1.default.createElement("circle", { cx: "11", cy: "11", r: "11", stroke: "none" }),
                react_1.default.createElement("circle", { cx: "11", cy: "11", r: "10.5", fill: "none" })),
            react_1.default.createElement("rect", { id: "Rectangle_2645", "data-name": "Rectangle 2645", width: "14", height: "3", transform: "translate(5 10.5)", fill: "#fff" })))));
exports.default = DeviationBlocker;
//# sourceMappingURL=deviationBlocker.js.map